/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Web_Card2_TitleInputs */

const tr_landing_web_card2_title = /** @type {(inputs: Landing_Web_Card2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tek katalog, tek stok`)
};

const en_landing_web_card2_title = /** @type {(inputs: Landing_Web_Card2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One catalogue, one stock level`)
};

const de_landing_web_card2_title = /** @type {(inputs: Landing_Web_Card2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Katalog, ein Bestand`)
};

const ru_landing_web_card2_title = /** @type {(inputs: Landing_Web_Card2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Один каталог, один остаток`)
};

/**
* | output |
* | --- |
* | "One catalogue, one stock level" |
*
* @param {Landing_Web_Card2_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_web_card2_title = /** @type {((inputs?: Landing_Web_Card2_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Web_Card2_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_web_card2_title(inputs)
	if (locale === "de") return de_landing_web_card2_title(inputs)
	if (locale === "ru") return ru_landing_web_card2_title(inputs)
	return tr_landing_web_card2_title(inputs)
});